<template>
    <p id="top_menu_partition" class="item">
        <span :data-tooltip="'字軌'" :data-position="'bottom left'">
            {{ partition.prefix }}
        </span>

        <span style="text-decoration: underline;">
            <span :data-tooltip="'起始號碼'" :data-position="'bottom center'">
                {{ integer_rjust(partition.from_number, partition.digit, "0") }}
            </span>
            <span> ~ </span>
            <span :data-tooltip="'結束號碼'" :data-position="'bottom center'">
                {{ integer_rjust(partition.to_number, partition.digit, "0") }}
            </span>
        </span>
        <span> (共{{ partition.to_number - partition.from_number +1 }}筆) </span>
    </p>

</template>

<script>
    export default {
        props: {
            partition: Object
        },
        mounted() {
        },
        computed: {
        },
        methods: {
            integer_rjust(integer, width, padding) {
                return integer.toString().rjust(width, padding)
            }
        }
    }
</script>
